module.exports = __webpack_public_path__ + "img/volop eten en drinken.66cd1846.jpg";